import * as types from '../../../constants/ActionTypes';

export const setApplicantScannedId = scannedId => ({
    type: types.SET_SCANNED_ID,
    scannedId,
});

export const setApplicantTakenPhoto = takenPhoto => ({
    type: types.SET_TAKEN_PHOTO,
    takenPhoto,
});

export const setVerification = verification => ({
    type: types.SET_VERIFICATION,
    verification,
});



// WEBPACK FOOTER //
// ./src/app/FormStepper/ApplicantIdVerification/applicantIderificationActions.js